import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { date, references } from '@apexdesigner/schema-tools';

export const notAvailable = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().describe('Name'),

    startDate: date()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('Start Date'),

    startTime: z.string().nullable().optional().describe('Start Time'),

    endDate: date()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('End Date'),

    endTime: z.string().nullable().optional().describe('End Time'),

    termId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Term'),

    termTutorId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to TermTutor'),

    selectedStudentId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to SelectedStudent'),

    alternateStudentId: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to AlternateStudent'),

    term: references('Term'),

    termTutor: references('TermTutor'),

    selectedStudent: references('SelectedStudent'),

    alternateStudent: references('AlternateStudent'),
  })
  .describe(
    'A period during which a term, tutor, selected student, or alternate student\ncannot attend. When the tutor/selected-student/alternate-student links are\nall unset, the record applies to the whole term.',
  )
  .as('NotAvailable');

export { notAvailable as notAvailableSchema };
